<template>
  <div class="training-student-page">
    <TrainingWrap>
      <template #default="{batchId}">
        <div class="cont-wrap">
          <template v-if="batchId">
            <TemplateDataGrid :key="batchId"
                              ref="grid"
                              gridId="trainingStudent"
                              v-bind="{batchId}"/>
          </template>
          <Hint v-else type="empty">请先选择批次</Hint>
        </div>
      </template>
    </TrainingWrap>
  </div>
</template>

<script>
import TrainingWrap from '../wrap'
import Hint from '../../../../../elements/Hint.vue'
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
export default {
  name: 'TrainingStudentPage',
  components: {
    TrainingWrap,
    Hint,
    TemplateDataGrid
  }
}
</script>

<style scoped lang="scss">
.training-student-page {
  height: 100%;
  .cont-wrap {
    height: 100%;
  }
}
</style>
